let Base64 = require("js-base64").Base64;
function filterSens(str) {
    // userType：1运营     2租户     4客服   5质检  6业务  7其他 
    let userType = JSON.parse(window.localStorage.user).info.userType;
    if (userType !== "2" && str) {
        if(window.localStorage.desensitization === '1') {
            if(str.length<=4){
                return str.substring(0, 1) + '**' 
            }else{
                return (str.substring(0, 3) + '****' + str.substring(3 + 4))
            }
        }else if(window.localStorage.desensitization === '2') {
          let len = str.length
          let countStr = ''
          for(let i = 0; i < len; i ++) {
            countStr += '*'
          }
          return countStr
        }else if(window.localStorage.desensitization === '0') {
          return str
        }
    } else {
        return str
    }
}
export default {
    base64Enshow(value, flag) {
        return flag && flag == '1' ?Base64.decode(value) : value
    },
    base64Enshowbase64De(name,value,flag){
        if(flag=='1'){
            value = Base64.decode(value)
            if (name == 'cust_phone') {
                return (value.substring(0, 3) + '****' + value.substring(3 + 4))
            } else if (name == 'cust_name') {
                let len = value.length
                let countStr = value.substring(0, 1)
                for (let i = 1; i < len; i++) {
                    countStr += '*'
                }
                return countStr
            }
        }else{
            return value;
        }
    },
    base64Filters(name,value,flag){
        if(flag=='1' && value){
            if (name == 'cust_phone') {
                return (value.substring(0, 3) + '****' + value.substring(3 + 4))
            } else if (name == 'cust_name') {
                let len = value.length
                let countStr = value.substring(0, 1)
                for (let i = 1; i < len; i++) {
                    countStr += '*'
                }
                return countStr
            }
        }else{
            return filterSens(value);
        }
    },
    base64En(value, flag){
        return flag && flag == '1' ? Base64.encode(value) : value
    },
    base64De(value) {
        // 解密
        return Base64.decode(value)
    },

}